import Image from 'next/image';
import React from 'react';

import { WebsiteConfiguration } from '@cineamo/api/models/website-configuration/WebsiteConfiguration.types';

import { cn } from '@cineamo/ui/src/helpers/cn';

import { Link } from '@/i18n/routing';
import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

type SecondaryLogoProps = React.ComponentProps<typeof Link> & {
    logoUrl: string;
};

const SecondaryLogo: React.FC<SecondaryLogoProps> = ({ className, logoUrl, href, ...props }) => {
    const domainConfiguration = useDomainConfiguration();
    const cinema = domainConfiguration?.cinema;
    return (
        <Link
            {...props}
            className={cn('relative flex justify-center flex-auto my-9 lg:my-24', className)}
            href={href || '/'}>
            <Image
                className="w-auto h-56 lg:h-72 max-w-[35%] lg:max-w-[350px] object-contain select-none"
                src={logoUrl}
                alt={cinema?.name}
                width={400}
                height={400}
                priority={true}
            />
        </Link>
    );
};

export default SecondaryLogo;

export type SecondaryLogoConfig = Pick<SecondaryLogoProps, 'logoUrl' | 'href'>;

export function getSecondaryLogoConfig(
    secondaryLogo: WebsiteConfiguration['secondaryLogo']
): SecondaryLogoConfig | null {
    if (!secondaryLogo?.url) return null;
    return {
        logoUrl: secondaryLogo.url,
        href: secondaryLogo.href
    };
}
